import axios from 'axios';

import { AnnualReport } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Id, getData } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

export function getAnnualReport(
  year: number,
  userId: Id | null,
  validationStatus: ValidationStatus | null,
  filterAfterAffiliation: boolean,
) {
  return axios
    .get<AnnualReport>(`/annual-report/${year}`, {
      params: {
        userId,
        validationStatus,
        filterAfterAffiliation,
      },
    })
    .then(getData);
}
